import '../../styles/Stats.css';
// Tu peux utiliser react-icons ou des emojis pour simplifier
// npm install react-icons
import { FaClock, FaCheckCircle, FaExclamationCircle, FaTools } from 'react-icons/fa';

const Stats = () => {
  // Simulé pour l'exemple (tu remplaceras par tes props ou ton fetch)
  const data = {
    nouveau: { count: 1, percent: 33 },
    enCours: { count: 1, percent: 33 },
    resolu: { count: 1, percent: 33 },
    ferme: { count: 0, percent: 0 },
    tempsMoyen: "29h" // Plomberie
  };

  return (
    <div className="stats-section">
      <div className="stats-container">
        
        {/* Titre de section */}
        <h2 className="stats-title">Notre impact en temps réel</h2>

        <div className="stats-grid">
          
          {/* CARTE 1 : EN COURS (Action) */}
          <div className="stat-card orange-glow">
            <div className="icon-box"><FaTools /></div>
            <div className="stat-content">
              <h3>En cours de traitement</h3>
              <div className="big-number">{data.enCours.count}</div>
              <p className="sub-text">Dossiers actifs ({data.enCours.percent}%)</p>
            </div>
          </div>

          {/* CARTE 2 : RÉSOLUS (Succès) */}
          <div className="stat-card green-glow">
            <div className="icon-box"><FaCheckCircle /></div>
            <div className="stat-content">
              <h3>Problèmes résolus</h3>
              <div className="big-number">{data.resolu.count}</div>
              <p className="sub-text">Victoires pour les locataires</p>
            </div>
          </div>

          {/* CARTE 3 : TEMPS DE RÉPONSE (Efficacité) */}
          <div className="stat-card blue-glow">
            <div className="icon-box"><FaClock /></div>
            <div className="stat-content">
              <h3>Temps moyen (Plomberie)</h3>
              <div className="big-number">{data.tempsMoyen}</div>
              <p className="sub-text">Rapidité d'intervention</p>
            </div>
          </div>

          {/* CARTE 4 : TOTAL (Optionnel ou Nouveau) */}
          <div className="stat-card gray-glow">
            <div className="icon-box"><FaExclamationCircle /></div>
            <div className="stat-content">
              <h3>Nouveaux signalements</h3>
              <div className="big-number">{data.nouveau.count}</div>
              <p className="sub-text">En attente de prise en charge</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Stats;